<template>
  <div class="gift wrapW">
    <div class="center">
      <img src="~@/assets/img/gift3.png">
      <div class="center_zi">
        <div class="name">企业定制化营销方案策划及营销宣传物料支持</div>
        <div class="Yname">SCHEME PLANNING AND PUBLICITY MATERIALS</div>
        <div class="describe">品牌营销及短促活动方案策划、产品设计及开模定制、集采定制&一件代发仓配支持</div>
        <img src="~@/assets/img/gift.png">
        <ul>
          <li>营销方案</li>
          <li>创意设计</li>
          <li>研发开模</li>
          <li>源头供应</li>
          <li>数据分析</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'scene',
  data () {
    return {
    }
  }
}
</script>
<style lang="stylus" scoped>
.gift
  margin-top 1.2rem
  text-align center
  margin-bottom .48rem
  .center
    display flex
    align-items center
    margin-top 1.16rem
    .center_zi
      text-align left
      margin-left 1.2rem
      .name
        font-size .24rem
        color var(--hei)
        font-weight bold
        line-height .24rem
      .Yname
        margin-top .16rem
        font-size .20rem
        color #D22016
        font-weight bold
      .describe
        font-size .18rem
        margin-top .3rem
        color #666666
      img
        width .58rem
        margin-top .32rem
        margin-left 0
      ul
        display flex
        flex-flow row wrap
        margin-top .26rem
        li
          margin-right .4rem
          color #666666
          font-size .18rem
          position relative
          line-height 18px
          padding-left 16px
        li::before
          content ''
          width 6px
          height 6px
          border-radius 50%
          position absolute
          background #0067FF
          left 0px
          top 6px
</style>



// WEBPACK FOOTER //
// src/pages/index/components/giftT.vue